"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("main.dashboard", {
      url: "dashboard",
      resolve: {
        model: [
          "Dashboard",
          function (Dashboard) {
            return Dashboard.dashboard().$promise;
          },
        ],
        requiredApprovals: [
          "PromotionRequest",
          function (PromotionRequest) {
            var params = {
              page: 1,
              pageSize: 1000,
              requiresApproval: true,
            };

            return PromotionRequest.list(params).$promise;
          },
        ],
        chartData: [
          "Dashboard",
          function (Dashboard) {
            return Dashboard.dashboardCharts().$promise
              .catch(function () { return {}; });
          },
        ],
      },
      views: {
        main: {
          templateUrl: "/modules/Commom/dashboard/views/dashboard.html",
          controller: "dashboardCtrl",
          controllerAs: "vm",
        },
      },
    });

    $stateProvider.state("main.dashboard-colors", {
      url: "dashboardcolors",
      params: {
        expired: false,
      },
      resolve: {
        managers: [
          "Internal",
          function (Internal) {
            return Internal.ownUsersList({ pageSize: 0, isManager: true }).$promise;
          },
        ],
        states: [
          "Internal",
          function (Internal) {
            return Internal.states().$promise;
          },
        ],
        status: [
          "Status",
          function (Status) {
            return Status.listIds({
              moduleId: window.enumerators.modules.Cores,
            }).$promise;
          },
        ],
        commercial: [
          "ColorRequest",
          function (ColorRequest) {
            return ColorRequest.dashboardCommercial().$promise.catch(function () { return {}; });
          },
        ],
        operational: [
          "ColorRequest",
          function (ColorRequest) {
            return ColorRequest.dashboardOperational().$promise.catch(function () { return {}; });
          },
        ],
        designers: [
          "ColorRequest",
          function (ColorRequest) {
            return ColorRequest.dashboardDesigners().$promise.catch(function () { return {}; });
          },
        ],
        segmentation: [
          "ColorRequest",
          function (ColorRequest) {
            return ColorRequest.dashboardSegmentation().$promise.catch(function () { return {}; });
          },
        ],
      },
      views: {
        main: {
          templateUrl:
            "/modules/Commom/dashboard/views/dashboard.colors.html",
          controller: "dashboardColorsCtrl",
          controllerAs: "vm",
        },
      },
    });
  });
